import { Badge } from '..';

export const StatusTabs = ({ tabs, activeTab, onTabChange, dataCount = {} }) => {
  return (
    <div className="flex">
      {tabs.map(tab => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`px-4 py-2 flex flex-1 font-medium text-sm border-b transition-colors gap-2 items-center ${
            activeTab === tab.key ? 'border-interactive text-interactive' : 'border-b hover:border-b-hover'
          }`}
        >
          {tab.label}
          {dataCount[tab.key] > 0 && <Badge variant={'SolidPrimaryBorderless'}>{dataCount[tab.key]}</Badge>}
        </button>
      ))}
    </div>
  );
};
